import { By, ObjectId, Timestamp } from "../../../types";
import { ActivityDataWithType, ActivityRendererType } from "../types";

export enum CustomerActivityAction {
  None = 0,
  Add,
  Edit,
  Delete,
}

export interface CustomerActivityAdd {
  customer: ObjectId;
  fullname: string;
  national_code: string;
  phone: string;
  address: string;
  tags: Array<ObjectId>;
}

export interface CustomerActivityEdit {
  customer: ObjectId;
  fullname: string;
  national_code: string;
  phone: string;
  address: string;
  tags: Array<ObjectId>;
}

export interface CustomerActivityDelete {
  customer: ObjectId;
  fullname: string;
  national_code: string;
  phone: string;
  address: string;
  tags: Array<ObjectId>;
}

export type CustomerActivityData =
  | CustomerActivityAdd
  | CustomerActivityEdit
  | CustomerActivityDelete;

export interface CustomerActivity {
  action: CustomerActivityAction;
  data: CustomerActivityData;
}

export interface CustomerActivityDataWithType {
  type: ActivityRendererType;
  activity: CustomerActivityData;
  date: Timestamp;
  by: By;
}

export interface CustomerActivityRendererProps extends ActivityDataWithType {}
